import React from 'react';
import { FiX } from 'react-icons/fi';

export default function TimeTableModal({ isOpen, onClose, classInfo }) {
    if (!isOpen || !classInfo) return null;

    const { title, subTitle, schedules } = classInfo;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-4 bg-gray-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-2xl md:rounded-3xl w-full max-w-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300 flex flex-col max-h-[90vh]">
                {/* Fixed Header - Scaled for Mobile */}
                <div className="px-5 py-4 sm:px-8 sm:py-6 bg-blue-600 text-white flex justify-between items-center shrink-0">
                    <div>
                        <h3 className="text-lg sm:text-xl font-bold uppercase tracking-tight lemon-milk">{title} Timetable</h3>
                        <p className="text-blue-100 text-xs sm:text-sm font-medium poppins">{subTitle}</p>
                    </div>
                    <button onClick={onClose} className="bg-white/10 hover:bg-white/20 p-2 rounded-lg sm:rounded-xl transition-all active:scale-95">
                        <FiX size={20} className="sm:size-6" />
                    </button>
                </div>

                {/* Scrollable Content Area */}
                <div className="p-4 sm:p-8 overflow-y-auto custom-scrollbar">
                    {/* Desktop Table View (Hidden on mobile) */}
                    <div className="hidden md:block overflow-hidden rounded-2xl border border-gray-100 shadow-sm mb-6">
                        <table className="w-full text-left">
                            <thead className="bg-gray-50 border-b border-gray-100 sticky top-0 z-10">
                                <tr>
                                    <th className="px-6 py-4 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50">Class</th>
                                    <th className="px-6 py-4 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50">Day</th>
                                    <th className="px-6 py-4 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50">Time</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50 poppins">
                                {schedules && schedules.map((schedule, idx) => (
                                    <tr key={idx} className="hover:bg-blue-50/50 transition-colors">
                                        <td className="px-6 py-4">
                                            <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-black">
                                                {schedule.class}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-sm font-bold text-gray-700">{schedule.day}</td>
                                        <td className="px-6 py-4 text-sm text-gray-600 font-medium">{schedule.time}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile Card View (Hidden on desktop) */}
                    <div className="md:hidden space-y-3 mb-6">
                        {schedules && schedules.map((schedule, idx) => (
                            <div key={idx} className="p-4 rounded-xl border border-gray-100 bg-gray-50/30 space-y-2.5">
                                <div className="flex items-center justify-between">
                                    <span className="px-2 py-0.5 bg-blue-600 text-white rounded text-[10px] font-black uppercase tracking-wider shadow-sm">
                                        {schedule.class}
                                    </span>
                                    <span className="text-xs font-black text-gray-900 poppins uppercase tracking-tight">
                                        {schedule.day}
                                    </span>
                                </div>
                                <div className="flex items-center gap-2 text-gray-500">
                                    <div className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                                    <p className="text-xs font-bold poppins">{schedule.time}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="flex justify-end sticky bottom-0 z-10 pb-4 md:pb-0 bg-white md:bg-transparent">
                        <button
                            onClick={onClose}
                            className="w-full sm:w-auto px-6 py-2.5 bg-gray-100 text-gray-600 font-bold rounded-xl hover:bg-gray-200 transition-all text-xs sm:text-sm active:scale-95 poppins shadow-sm"
                        >
                            Close Portal
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
